// @ts-check

import React from 'react';
import useMenus from './useMenus';
import LoadingBackdrop from 'components/LoadingBackdrop';
import AppList from 'containers/pages/menus/components/AppList';
import Paper from '@mui/material/Paper';
import sty from './Menus.module.css';

/**
 * @component Menus
 * @returns {JSX.Element}
 */
function Menus() {
	const { loading, menus, roles, tabs, onMenu, onUpdateMenu } = useMenus();

	/**
	 * @function renderAppList
	 * @param {{appId:string, appName:string, groups:object[]}} menu
	 * @param {number} index
	 * @returns {JSX.Element}
	 */
	const renderAppList = (menu, index) => (
		<AppList
			key={index}
			menu={menu}
			menus={menus}
			roles={roles}
			tabs={tabs}
			onMenu={onMenu}
			onUpdateMenu={onUpdateMenu}
		/>
	);

	return (
		<Paper className={sty.paper}>
			{menus.map(renderAppList)}
			<LoadingBackdrop open={loading} />
		</Paper>
	);
}

export default Menus;
